import { CONSTANTS } from "@app/config/constants";
import { ClientStudyRequest } from "./clientStudyRequest.model";
import { environment } from "src/environments/environment";

export class ElectronicSignatureRequest {
  public static toRequest(
    clientStudyForm: ClientStudyRequest,
    tokenAccess: string,
    urlRequestQuota: string
  ) {
    const { clientType, companyName, documentNumber, documentType, email, legalRepresentativeFirstName,
        legalRepresentativeFistLastName, sellerDocumentNumber, sellerDocumentType } = clientStudyForm;
    const identifier = sellerDocumentNumber + new Date().getTime();

    return {
      id: identifier,
      correoComprador: email,
      documento: sellerDocumentNumber,
      documentoAfiliado: documentNumber,
      nombreComprador:
        clientType === CONSTANTS.CLIENT_STUDY.LEGAL
          ? companyName
          : `${legalRepresentativeFirstName} ${legalRepresentativeFistLastName}`,
      tipoDoc:
        clientType !== CONSTANTS.CLIENT_STUDY.LEGAL
          ? sellerDocumentType
          : CONSTANTS.CLIENT_STUDY.NIT,
      tipoDocAfiliado: documentType,
      token: tokenAccess,
      urlCupo: urlRequestQuota,
      urlLanding: environment.electronicSignatureUrl + `?idUnico=${identifier}`,
    };
  }
}

export interface ReturnElectronicSignatureResponse {
  ok?: boolean;
  message?: string;
  data?: ReturnElectronicSignatureData;
  status?: number;
}
export interface ReturnElectronicSignatureData {
  id: string;
  fecha: string;
  urlCupo: string;
  token: string;
  tipoDoc: string;
  documento: string;
  tipoDocAfiliado: string;
  documentoAfiliado: string;
  correoComprador: string;
  urlLanding: string;
  firmaDigital: boolean;
  envioCorreoNoFirma: boolean;
  nombreComprador: string;
}
